import React from "react";

import LoginView from "../modules/Login";

function LoginPage() {
  return <LoginView />;
}

export default LoginPage;
